module.exports = __webpack_public_path__ + "img/whatsApp.8e2fe2ca.png";